export default __webpack_public_path__ + "static/media/k4.fff54ade.svg";